module.exports = __webpack_public_path__ + "static/calorex-header-greenfoam-1280-51cbe22ca526872f9f3be66a0925a990.jpg";